import { TableCell, TableCellProps } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';

interface TableCellValueProps {
  value: string | JSX.Element;
  onClick?: () => void;
  tableCellProps?: TableCellProps;
}

export const TableCellValue = ({ value, onClick, tableCellProps }: TableCellValueProps) => (
  <TableCell onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'auto' }} {...tableCellProps}>
    <Font variant={'body2'} color={'textPrimary'}>
      {value}
    </Font>
  </TableCell>
);
